<template>
  <div>
    <div>
      <!-- formData.type == 7 搜索组件-->
      <div class="style_box">
        <div>
          <div class="title_box">
            <div class="title_text">
              <Icon style="font-size: 20px" type="ios-arrow-down" />搜索编辑
            </div>
          </div>
          <div style="margin: 10px 0">
            <Form label-position="right" :label-width="70">
              <FormItem style="margin: 0 0 10px 0" label="背景色">
                <ColorPicker v-model="formData.content.bgColor" />
              </FormItem>
              <FormItem style="margin: 0 0 10px 0" label="搜索框">
                <div style="margin-bottom: 5px" class="just_sb">
                  <div class="display_flex">
                    <div class="kuai_box">高</div>
                    <Input
                      v-model="formData.content.height"
                      placeholder="0"
                      style="width: 120px"
                    ></Input>
                  </div>
                  <div class="display_flex">
                    <div class="kuai_box">圆角</div>
                    <Input
                      v-model="formData.content.radius"
                      placeholder="0"
                      style="width: 120px"
                    ></Input>
                  </div>
                </div>
              </FormItem>
              <FormItem style="margin: 0 0 10px 0" label="上下间距">
                <div>
                  <Slider
                    v-model="formData.content.paddingData.topBottom"
                  ></Slider>
                </div>
              </FormItem>
              <FormItem style="margin: 0 0 10px 0" label="左右间距">
                <div>
                  <Slider
                    v-model="formData.content.paddingData.leftRight"
                  ></Slider>
                </div>
              </FormItem>
              <FormItem style="margin: 0 0 10px 0" label="文字内容">
                <Input
                  v-model="formData.content.text"
                  placeholder="请输入文字内容"
                ></Input>
              </FormItem>
              <FormItem label="字体大小">
                <div class="just_sb">
                  <Input
                    v-model="formData.content.size"
                    placeholder="请输入字号"
                    style="width: 240px"
                  ></Input>
                  <ColorPicker v-model="formData.content.textColor" />
                </div>
              </FormItem>
            </Form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props:{
        formData:{
            type:Object,
            default:{}
        }
    },
    data() {
        return {
        }
    },
};
</script>

<style scoped>
.style_box {
  padding: 0 10px;
}
.title_box {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
}

.title_text {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
}
.just_sb {
  display: flex;
  align-items: center;
  justify-content: space-between;
} 
.display_flex {
  display: flex;
}
.kuai_box {
  width: 30px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  border-radius: 5px 0 0 5px;
  border: 1px solid #bfbfbf;
}
</style>